module.exports = __webpack_public_path__ + "static/media/bsi.975a1620.svg";